import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Route, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AuthorisationGuard } from '../shared/guards/authorisation.guard';
import { OnBoardingGuard } from './guards/on-boarding.guard';
import { OnBoardingLayoutComponent } from './layout/on-boarding-layout/on-boarding-layout.component';
import { QuestionnaireComponent } from './containers/questionnaire/questionnaire.component';
import { BillingAddressComponent } from './containers/billing-address/billing-address.component';
import { LocalizationGuard } from '@api-ui-app/src/app/shared/guards/localization.guard';
import { QuickQuestionComponent } from './containers/quick-question/quick-question.component';
import { QuickQuestionAnswerSelectionControlComponent } from './components/quick-question-answer-control/quick-question-answer-selection-control.component';
import { OnBoardingFacade } from '@api-ui-app/src/app/on-boarding/on-boarding.facade';
import { QuickQuestionsModule } from '@gelato-api-ui/core/quick-questions/quick-questions.module';
import { PreserveQueryParamsGuard } from '@api-ui-app/src/app/dashboard/guards/preserve-query-params.guard';
import { CountryStateSelectorModule } from '@gelato-api-ui/sdk/src/lib/shared/country-state-selector/country-state-selector.module';
import { CountrySelectorModule } from '@gelato-api-ui/sdk/src/lib/shared/country-selector/country-selector.module';
import { PhoneFieldModule } from '@gelato-api-ui/ui-kit/src/lib/phone-field/phone-field.module';
import { TermsAndConditionsComponent } from '@gelato-api-ui/ui-kit/src/lib/terms-and-conditions/terms-and-conditions.component';

const routes: Route[] = [
  {
    path: '',
    component: OnBoardingLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'questionnaire' },
      {
        path: 'questionnaire',
        pathMatch: 'full',
        component: QuestionnaireComponent,
        canActivate: [LocalizationGuard, PreserveQueryParamsGuard, AuthorisationGuard],
      },
      {
        path: 'billing-address',
        pathMatch: 'full',
        component: BillingAddressComponent,
        canActivate: [OnBoardingGuard],
      },
    ],
  },
];

@NgModule({
  declarations: [
    QuestionnaireComponent,
    BillingAddressComponent,
    OnBoardingLayoutComponent,
    QuickQuestionComponent,
    QuickQuestionAnswerSelectionControlComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    QuickQuestionsModule,
    CountryStateSelectorModule,
    CountrySelectorModule,
    PhoneFieldModule,
    TermsAndConditionsComponent,
  ],
  providers: [OnBoardingFacade],
})
export class OnBoardingModule {}
